export default "__VITE_ASSET__CqJstAEG__"